// Shared constants for admin components

export const MEMBER_CLUBS = [
  { id: "bsv-niners", label: "BSV" },
  { id: "dsv-niners", label: "DSV" },
  { id: "sdv-niners", label: "SDV" },
  { id: "soundtheatre", label: "TST" },
  { id: "vip", label: "VIP" },
  { id: "perchten", label: "Perchten" },
];

export const INTERVALS = [
  { value: "monthly", label: "Monatlich" },
  { value: "half_year", label: "Halbjährlich" },
  { value: "year", label: "Jährlich" },
];

export const DESC_FIELDS = [
  { key: "subtitle", label: "Untertitel", type: "input" },
  { key: "intro", label: "Einleitung", type: "textarea" },
  { key: "text", label: "Haupttext", type: "textarea" },
  { key: "visionTitle", label: "Vision-Überschrift", type: "input", placeholder: "z.B. Was dich erwartet:" },
  { key: "vision", label: "Vision-Punkte (einer pro Zeile)", type: "textarea" },
  { key: "quote", label: "Zitat / Highlight", type: "textarea" },
  { key: "closing", label: "Abschlusstext", type: "textarea" },
  { key: "email", label: "E-Mail", type: "input" },
  { key: "instagram", label: "Instagram", type: "input" },
];

export const DOWNLOAD_CATEGORIES = ["Allgemein", "Formulare", "Anleitungen", "Vereinsdokumente", "Spielprotokolle", "Sonstiges"];

export const DOWNLOAD_CLUBS = [
  { id: "none", label: "Alle Vereine / Kein Verein" },
  { id: "dsv-niners", label: "DSV Niners Wels" },
  { id: "sdv-niners", label: "SDV Niners Wels" },
  { id: "bsv-niners", label: "BSV Niners Wels" },
  { id: "perchten", label: "D'Wösa Höllen Viecha" },
  { id: "soundtheatre", label: "Soundtheatre" },
];
